var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value.length)?_c('div',_vm._l((_vm.value),function(item,index){return _c('div',{staticClass:"mb-2"},[_c('span',{staticClass:"badge badge-light text-capitalize"},[_vm._v("\n            "+_vm._s(item.name)+"\n        ")])])}),0):_c('div',[_vm._v(" -")])])
}
var staticRenderFns = []

export { render, staticRenderFns }